/**
 * EmptyFilterBox — empty-state prompt shown in the filter panel when
 * no filter conditions have been added yet.
 *
 * Displays a single "Add Condition" button inside a styled container
 * to guide the user toward creating their first filter row.  Once at
 * least one condition exists, FilterPanel switches to rendering
 * FilterRow components instead of this component.
 */
import React from 'react'
import { Box } from '@mui/material'
import GenericButton from '../../../../../components/GenericButton'
import { CirclePlus } from 'lucide-react'
import { ButtonSize, ButtonType } from '../../../../../components/GenericButton/styles'
import { shade } from '../../../../../colors'

interface EmptyFilterBoxProps {
  onAddCondition: () => void
}

const EmptyFilterBox: React.FC<EmptyFilterBoxProps> = ({ onAddCondition }) => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    mt={4}
    flexDirection="column"
    border={`1px solid ${shade[650]}`}
    padding="24px 16px"
    borderRadius="8px"
    bgcolor={shade[750]}
  >
    <GenericButton
      buttonType={ButtonType.Secondary}
      buttonSize={ButtonSize.Medium}
      startIcon={<CirclePlus />}
      onClick={onAddCondition}
      label="Add Condition"
    />
  </Box>
)

export default EmptyFilterBox
